/* eslint-disable vue/attribute-hyphenation */
<!-- MACULA Photo component -->
<template>
  <md-card id="macula" class="md-with-hover" @mouseover.native="mouseOver" @mouseleave.native="mouseLeave">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="md-layout">
        <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
          <md-icon>remove_red_eye</md-icon>
        </div>
        <div class="md-layout-item">
          <h4 class="title" style="font-weight: 400">MACULAR OCT</h4>
        </div>
        <div class="md-layout md-layout-item md-alignment-center-right">
          <md-button
            v-show="addnlOCT"
            slot="title"
            class="md-button md-warning md-sm"
            style="margin-top: 15px; margin-right: 10%"
            @click.prevent="toggleImgBox"
          >
            ADD'L IMAGES
          </md-button>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <!-- ROW HEADINGS -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: center">
        <div class="md-layout-item">
          <label for="diagMacOD" style="font-weight: bold">RIGHT</label>
        </div>

        <div class="md-layout-item">
          <label for="diagMacOS" style="font-weight: bold">LEFT</label>
        </div>
      </div>
      <hr style="width: 98%" />

      <!-- ROW images -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: Left">
        <div class="md-layout-item" style="padding: 2px 5px 2px 20px">
          <drop class="drop" @drop="handleDropOD">
            <img
              v-if="noMacOD"
              :style="imgStyle"
              name="paceholder"
              src="@/assets/img/imageNA.jpg"
              height="100px"
              width="auto"
            />

            <img
              v-else
              :src="imgMacOD_Url"
              :style="imgStyle"
              name="imgMacOD"
              alt="Macula OD"
              height="100px"
              width="auto"
              @click="macModal(imgMacOD_Url)"
            />
          </drop>
        </div>

        <div class="md-layout-item" style="padding: 2px">
          <drop class="drop" @drop="handleDropOS">
            <img
              v-if="noMacOS"
              :style="imgStyle"
              name="imgMacOS"
              src="@/assets/img/imageNA.jpg"
              alt="Macula OS"
              height="100px"
              width="auto"
            />

            <img
              v-else
              :src="imgMacOS_Url"
              :style="imgStyle"
              name="imgMacOS"
              alt="Macula OS"
              height="100px"
              width="auto"
              @click="macModal(imgMacOS_Url)"
            />
          </drop>
        </div>
      </div>
      <hr style="width: 98%" />

      <!-- ROW LISTBOXES -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="margin-left: -15px">
        <findings-search :section="Section" :sectionName="SectionName" :mState="mState" />

        <hr style="margin: 0; padding: 0" />
      </div>
    </md-card-content>

    <hr />

    <!-- MODAL LARGE IMAGE -->
    <modal v-if="winModal" md-dynamic-height>
      <template slot="header">
        <div class="md-layout md-alignment-center-right">
          <div class="md-layout-item"></div>
          <div class="md-layout-item md-alignment-top-right" align="right">
            <md-icon class="exit-icon" style="color: red" @click.native="winModal = false">cancel</md-icon>
          </div>
        </div>
      </template>
      <template slot="body">
        <div v-if="MacModal" class="md-layout" @click="winModal = false">
          <div class="md-layout-item">
            <img :src="ModalImg" height="300px;" width="auto" />
          </div>
        </div>
      </template>
    </modal>
  </md-card>
</template>

<script>
import { mapGetters } from "vuex"
import { Modal } from "@/components"
import { bus } from "@/main"
import FindingsSearch from "@/components/GlobeChek/screening/findings/Top5Findings"
export default {
  name: "PhotoMacula",
  components: {
    "findings-search": FindingsSearch,
    Modal
  },
  props: {},
  data() {
    return {
      Section: "Macula",
      SectionName: "Macular OCT",
      replaceImgOD: null,
      replaceImgOS: null,
      mState: false,
      ModalImg: "",
      normal: null,
      normalStyle: "",
      winModal: false,
      MacModal: false,
      imgStyle: "",
      imgStyleInactive: "filter:grayscale(100%);",
      imgStyleActive: ""
    }
  },
  computed: {
    ...mapGetters(["maculaPhoto", "imagesPath", "addnlOCT", "getImageUrlByIds"]),

    noMacOD() {
      if (this.replaceImgOD) {
        return false
      } else {
        if (this.getImageUrlByIds("macula", ["MACOD"]) == false) {
          return true
        }
      }
    },
    noMacOS() {
      if (this.replaceImgOS) {
        return false
      } else {
        if (this.getImageUrlByIds("macula", ["MACOS"]) == false) {
          return true
        }
      }
    },
    imgMacOD_Url() {
      if (this.replaceImgOD) {
        return this.replaceImgOD
      } else {
        return this.getImageUrlByIds("macula", ["MACOD"])
      }
    },
    imgMacOS_Url() {
      if (this.replaceImgOS) {
        return this.replaceImgOS
      } else {
        return this.getImageUrlByIds("macula", ["MACOS"])
      }
    }
  },
  mounted: function () {
    this.imgStyle = this.imgStyleInactive
  },
  methods: {
    toggleImgBox() {
      bus.$emit("toggleImgBox", "OCT")
    },
    mouseOver: function () {
      try {
        this.mState = true
        this.imgStyle = this.imgStyleActive
        this.normalStyle = false
      } catch (error) {
        console.log(error)
      }
    },
    mouseLeave: function () {
      try {
        this.mState = false
        this.imgStyle = this.imgStyleInactive
        this.normalStyle = "disabled"
      } catch (error) {
        console.log(error)
      }
    },
    clearModal() {
      this.winModal = false
      this.MacModal = false
      this.FindingModal = false
    },
    macModal: function (img) {
      this.clearModal()
      this.ModalImg = img
      this.winModal = true
      this.MacModal = true
    },
    handleDropOD(data) {
      //console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImgOD = data.url
      this.$store.dispatch("SetImgReplace", { MACOD: data.url })
      this.$forceUpdate()
    },
    handleDropOS(data) {
      //console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImgOS = data.url
      this.$store.dispatch("SetImgReplace", { MACOS: data.url })
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
#macula {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.values {
  font-size: 0.7rem;
  padding: 0px;
  margin-top: 10px;
  line-height: 1.4em;
  font-weight: 200;
}

.values2 {
  padding: 0px;
  font-weight: 350;
  font-size: 12pt;
  line-height: 14px;
  align-content: start;
}

.mswitch {
  color: rgba(46, 46, 46, 0.8) !important;
  font-size: 0.8rem;
}

.mswitch-normal {
  color: rgba(0, 98, 211, 0.8) !important;
  font-size: 0.95rem;
}

.drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 0px;
  background: #ccc;
  position: relative;
  padding: 0px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}

.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
}
</style>
